import React, { useEffect, useState } from 'react';

import { useMedia } from 'react-use';
import userService from '../services/UserService';
import { showToast } from '../shared/Toast';
import { SbCurrentUser } from '../submission_boards/component/SbModel';
import Button from '../submission_boards/component/Button';
import { CircleCheckBigIcon, CircleCheckIcon } from 'lucide-react';
import { isDownGradeUserPlan, MasterPlan, SubscriptionTier, UserPlan } from './UserPlanModal';
import DowngradePlanPage from './DowngradePlan';
import Breadcrumb2 from '../shared/Breadcrumb2';

interface StripConfirmPageProps {
  currentUser: SbCurrentUser;
  user_plans: UserPlan[];
  master_plans: MasterPlan[];
}

export default function StripConfirmPage({
  currentUser,
  user_plans,
  master_plans,
}: StripConfirmPageProps) {
  const is400_639Screen = useMedia('(min-width: 400px) and (max-width: 639px)', false);

  const [masterPlans, setMasterPlans] = useState<MasterPlan[]>([]);
  const [userPlans, setUserPlans] = useState<UserPlan[]>([]);
  const [monthlyYearly, setmonthlyYearly] = useState<number>(0);
  const [retryFetch, setretryFetch] = useState<number>(4);

  useEffect(() => {
    console.log('UserPlansPage useEffect currentUser');
    fetchUserPlans();
  }, [currentUser]);

  const isPlanActive = (subscription_tier: string, stripe_product_id: string) => {
    const userPlan: UserPlan = userPlans.find((item) => {
      return (
        masterPlans.filter((item2) => {
          return (
            item2.stripe_product_id == item.stripe_product_id &&
            subscription_tier == item2.subscription_tier &&
            stripe_product_id == item2.stripe_product_id
          );
        }).length > 0
      );
    });
    if (userPlan) {
      return true;
    }
    return false;
  };

  const getPlanTitle = (subscription_tier) => {
    console.log(masterPlans);
    const item: MasterPlan = masterPlans.find(
      (item) => item.subscription_tier == subscription_tier
    );
    if (item) {
      return item.plan_name;
    }
    return 'Basic';
  };
  const fetchUserPlans = async () => {
    try {
      const resp = await userService.getUserPlans();
      if (resp) {
        if ('user_plans' in resp) {
          setUserPlans(resp.user_plans);
        } else {
          setUserPlans([]);
          setTimeout(() => {
            if(retryFetch >= 0) {
              fetchUserPlans();
              setretryFetch(retryFetch-1);
            }
          }, 2000);
        }
        if ('master_plans' in resp) {
          setMasterPlans(resp.master_plans);
        }
      }
    } catch (error) {
      showToast('Error while cancelling subscription.', 'danger');
    } finally {
    }
  };
 
  return (
    <div className="w-full flex flex-col flex-1 mx-auto pb-1 bg-gray-50">
      <>
        <Breadcrumb2
          pages={[
            { name: 'Membership', href: '#', current: false },
            { name: 'Confirm', href: '#', current: true },
          ]}
        ></Breadcrumb2>
        {userPlans.length <= 0 && <div className="w-full flex flex-col flex-1 mx-auto pb-1 bg-gray-50 px-4 sm:px-6 lg:px-8 ">
          <div className="w-full max-w-6xl mx-auto relative py-14 flex flex-col gap-8 justify-center items-center">
            <div className="w-16 h-16 text-blue-500 ">
              <CircleCheckBigIcon className="w-16 h-16" />
            </div>
            <div className="font-semibold text-5xl text-gray-900 justify-center items-center text-center">
              Checking...
            </div>
          </div>
        </div>}
        {userPlans.length > 0 && <div className="w-full flex flex-col flex-1 mx-auto pb-1 bg-gray-50 px-4 sm:px-6 lg:px-8 ">
          <div className="w-full max-w-6xl mx-auto relative py-14 flex flex-col gap-8 justify-center items-center">
            <div className="w-16 h-16 text-blue-500 ">
              <CircleCheckBigIcon className="w-16 h-16" />
            </div>
            <div className="font-semibold text-4xl sm:text-5xl text-gray-900 justify-center items-center text-center">
              Your plan change is complete
            </div>
          <div className="w-full mx-auto relative flex flex-col gap-5 justify-center items-center">
            <div className="font-light text-2xl justify-center items-center text-center">
              You’ve successfully switched to the<br></br>
              <span className="font-semibold">{getPlanTitle(currentUser.subscription_tier)}.</span>
            </div>
            <div className="font-light text-2xl justify-center items-center text-center">
              You Membership will stay active <span className="font-semibold">until  {new Date(userPlans[0].end_date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                      })}</span>,<br/>after which your account will auto-renew every month.
            </div>
            <div className="justify-center items-center flex flex-row gap-2-1">
               <Button
                variant="secondary"
                id="manage_btn_id"
                btn_size="small"
                icon_position="hor"
                onClick={() => {
                  window.location.href = '/user_plans';
                }}
              >
                <span className="truncate">Manage Subscription</span>
              </Button>
              <Button
                variant="primary"
                id="continue_btn_id"
                btn_size="small"
                icon_position="hor"
                onClick={() => {
                  window.location.href = '/';
                }}
              >
                <span className="truncate">Continue to Filmik</span>
              </Button>
            </div>
          </div>
          </div>
        </div>}
      </>
    </div>
  );
}
